import Cookies from 'js-cookie';

import * as UserService from 'client/api/graph/User';
import { getApolloClient } from 'client/apolloClient';

import { IMPERSONATED_CLIENT_COOKIE } from '../../../../constants';


export const getClient = async (
  projectId: string,
  clientId = Cookies.get(IMPERSONATED_CLIENT_COOKIE) || '',
  client = getApolloClient(),
) => {
  try {
    const clientInfo = await client.query({
      query: UserService.GET_CLIENT,
      ...UserService.GET_CLIENT_DEFAULT_OPTIONS(projectId, clientId),
    });
    return clientInfo.data?.getClient;
  } catch (err) {
    console.log(err);
    throw Error();
  }
};
